var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.99996 14.2916C9.34514 14.2916 9.62496 14.0118 9.62496 13.6666V8.66663C9.62496 8.32145 9.34514 8.04163 8.99996 8.04163C8.65478 8.04163 8.37496 8.32145 8.37496 8.66663V13.6666C8.37496 14.0118 8.65478 14.2916 8.99996 14.2916Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99996 5.33329C9.4602 5.33329 9.83329 5.70639 9.83329 6.16663C9.83329 6.62686 9.4602 6.99996 8.99996 6.99996C8.53972 6.99996 8.16663 6.62686 8.16663 6.16663C8.16663 5.70639 8.53972 5.33329 8.99996 5.33329Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.041626 9.49996C0.041626 4.55241 4.05241 0.541626 8.99996 0.541626C13.9475 0.541626 17.9583 4.55241 17.9583 9.49996C17.9583 14.4475 13.9475 18.4583 8.99996 18.4583C4.05241 18.4583 0.041626 14.4475 0.041626 9.49996ZM8.99996 1.79163C4.74276 1.79163 1.29163 5.24276 1.29163 9.49996C1.29163 13.7572 4.74276 17.2083 8.99996 17.2083C13.2572 17.2083 16.7083 13.7572 16.7083 9.49996C16.7083 5.24276 13.2572 1.79163 8.99996 1.79163Z",
  fill: "currentColor"
})));
export default SvgInfo;